// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import HelloController from "./hello_controller";
application.register("hello", HelloController);

import OfferFilterController from "./offer_filter_controller";
application.register("offer-filter", OfferFilterController);

import TooltipController from "./tooltip_controller";
application.register("tooltip", TooltipController);

import WheelSizeController from "./wheel_size_controller";
application.register("wheel-size", WheelSizeController);

import DropdownController from "./dropdown_controller";
application.register("dropdown", DropdownController);

import CopyClipboardController from "./copy_clipboard_controller";
application.register("copy-clipboard", CopyClipboardController);

import TableFilterController from "./table_filter_controller";
application.register("table-filter", TableFilterController);

import ProductLinkerController from "./product_linker_controller";
application.register("product-linker", ProductLinkerController);

import ProductModelLinkerController from "./product_model_linker_controller";
application.register("product-model-linker", ProductModelLinkerController);

import SidebarController from "./sidebar_controller";
application.register("sidebar", SidebarController);

import DarkModeController from "./dark_mode_controller";
application.register("dark-mode", DarkModeController);

import ImportRunsController from "./import_runs_controller";
application.register("import-runs", ImportRunsController);

import HelpChatController from "./help_chat_controller";
application.register("help-chat", HelpChatController);

import ImageGalleryController from "./image_gallery_controller";
application.register("image-gallery", ImageGalleryController);
